import * as React from "react"

import { cn } from "@/shared/lib/utils"

export function mergeAsChildElement<P extends Record<string, unknown>>(
  child: React.ReactElement,
  props: P,
): React.ReactElement {
  const childProps = child.props as Record<string, unknown>

  return React.cloneElement(child, {
    ...childProps,
    ...props,
    className: cn(
      childProps.className as string | undefined,
      props.className as string | undefined,
    ),
  } as P)
}

export function getSingleChildElement(
  children: React.ReactNode,
): React.ReactElement {
  return React.Children.only(children) as React.ReactElement
}
